<div class="wrapper">
  <div class="tooltip" *ngIf="notiTooltipInput?.value != null" #tooltipDiv>
    <div class="date">
      <img src="assets/images/timeline/bell-gray.png" style="width: 16px; height: 16px; margin-right: 4px">
      <span style="padding: 1px">{{notiTooltipInput.date | date:'H:mm, d MMM'}}</span>
    </div>
    <div class="sensor-header">{{notiTooltipInput.type | sensorHeader}}</div>
    <div class="value-container">
      <span class="device-name">{{notiTooltipInput.selectedDevice?.deviceName}}: </span>
      <span style="font-weight: 700">{{notiTooltipInput.value | tempConverter: type: temperatureUnit | number: '1.1-1'}} </span>
      <span style="color:#868D94">{{notiTooltipInput.type | sensorUnit: temperatureUnit}}</span>
    </div>
  </div>
  <div class="tail-background"></div>
  <img class="tooltip-tail" src="assets/images/timeline/tooltip-arrow.png" />
</div>
